import { dew as _formatEtherDew } from "../utils/unit/formatEther.js";
import { dew as _formatGweiDew } from "../utils/unit/formatGwei.js";
import { dew as _baseDew } from "./base.js";
import { dew as _transactionDew } from "./transaction.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EstimateGasExecutionError = void 0;
  const formatEther_js_1 = _formatEtherDew();
  const formatGwei_js_1 = _formatGweiDew();
  const base_js_1 = _baseDew();
  const transaction_js_1 = _transactionDew();
  class EstimateGasExecutionError extends base_js_1.BaseError {
    constructor(cause, {
      account,
      docsPath,
      chain,
      data,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value
    }) {
      const prettyArgs = (0, transaction_js_1.prettyPrint)({
        from: account?.address,
        to,
        value: typeof value !== "undefined" && `${(0, formatEther_js_1.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
        data,
        gas,
        gasPrice: typeof gasPrice !== "undefined" && `${(0, formatGwei_js_1.formatGwei)(gasPrice)} gwei`,
        maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, formatGwei_js_1.formatGwei)(maxFeePerGas)} gwei`,
        maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, formatGwei_js_1.formatGwei)(maxPriorityFeePerGas)} gwei`,
        nonce
      });
      super(cause.shortMessage, {
        cause,
        docsPath,
        metaMessages: [...(cause.metaMessages ? [...cause.metaMessages, " "] : []), "Estimate Gas Arguments:", prettyArgs].filter(Boolean)
      });
      Object.defineProperty(this, "cause", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "EstimateGasExecutionError"
      });
      this.cause = cause;
    }
  }
  exports.EstimateGasExecutionError = EstimateGasExecutionError;
  //# sourceMappingURL=estimateGas.js.map
  return exports;
}